module.exports = __webpack_public_path__ + "img/token-swap-line.af209abe.svg";